import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="fixed top-4 right-4 z-50 bg-white rounded-full shadow-lg px-4 py-2 flex items-center gap-2">
      <button
        onClick={() => setLanguage('zh-TW')}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
          language === 'zh-TW'
            ? 'bg-teal-500 text-white'
            : 'text-gray-600 hover:bg-gray-100'
        }`}
      >
        繁體
      </button>
      <button
        onClick={() => setLanguage('zh-CN')}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
          language === 'zh-CN'
            ? 'bg-teal-500 text-white'
            : 'text-gray-600 hover:bg-gray-100'
        }`}
      >
        简体
      </button>
    </div>
  );
};

export default LanguageSwitcher;
